"use client";

import React from "react";
import { CircleCheck, Globe, Zap, Wrench } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "15+ Years Expertise",
  description: "Deep R&D heritage in intelligent sorting equipment.",
  icon: CircleCheck
}, {
  title: "Global Service Network",
  description: "Local support across 50+ countries.",
  icon: Globe
}, {
  title: "Proven Reliability",
  description: "99.9% sorting accuracy validated in production.",
  icon: Zap
}, {
  title: "Tailored Solutions",
  description: "End-to-end engineering for your workflow.",
  icon: Wrench
}];
export default function WhyChooseUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="252304" id="why-choose-us" className="bg-background text-foreground py-20 md:py-28">
      <div className="page-container">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-12 md:mb-16 font-default tracking-tight">
          Why Choose Us
        </h2>

        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full bg-card border-border hover:border-primary/50 transition-all duration-300 shadow-md hover:shadow-xl rounded-lg">
                  <CardHeader className="pb-4">
                    <div className="w-12 h-12 rounded-lg bg-primary flex items-center justify-center mb-4 shadow-sm">
                      <Icon className="w-6 h-6 text-primary-foreground" />
                    </div>
                    <CardTitle className="text-xl font-default text-card-foreground font-semibold">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground text-base leading-relaxed font-default">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}